var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWinrar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1755078800765,
    className: "icon",
    viewBox: "0 0 1048 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1874,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 339.668293h1048.97561v344.663414H0z",
    fill: "#F95F5D",
    "p-id": 1875
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1043.980488 339.668293V64.936585c0-34.965854-29.970732-64.936585-64.936586-64.936585H64.936585C29.970732 0 0 29.970732 0 64.936585v274.731708h1043.980488z m0 0",
    fill: "#55C7F7",
    "p-id": 1876
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 684.331707v274.731708c0 34.965854 29.970732 64.936585 64.936585 64.936585h919.102439c34.965854 0 64.936585-29.970732 64.936586-64.936585v-274.731708H0z m0 0",
    fill: "#7ECF3B",
    "p-id": 1877
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M409.6 0h234.770732v1024H409.6z",
    fill: "#FDAF42",
    "p-id": 1878
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M644.370732 444.565854v144.858536H399.609756V444.565854h244.760976m39.960975-59.941464H359.64878c-4.995122 0-14.985366 4.995122-14.985365 14.985366v229.77561c0 4.995122 4.995122 14.985366 14.985365 14.985366h324.682927c4.995122 0 14.985366-4.995122 14.985366-14.985366V399.609756c-4.995122-9.990244-9.990244-14.985366-14.985366-14.985366z m0 0",
    fill: "#FFFFFF",
    "p-id": 1879
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinrar);
export default __webpack_public_path__ + "static/media/winrar.afef6761.svg";
export { ForwardRef as ReactComponent };